import React from "react";

const TIMELINE = [
  {
    place: "University of Alberta, Canada",
    detail: "MSc Plastic Surgery — Highest Honours",
  },
  {
    place: "University of Alberta, Canada",
    detail: "Fellow of Plastic Surgery",
  },
  {
    place: "United Kingdom",
    detail: "MRCS England — Member of the Royal College of Surgeons of England",
  },
  {
    place: "London, England",
    detail: "GMC London Registered — General Medical Council",
  },
];

export function AboutCredentials() {
  return (
    <section
      id="about"
      className="scroll-mt-28 py-section px-6 md:px-10"
    >
      <div className="mx-auto max-w-[900px]">
        <h2 className="text-center font-heading text-4xl font-semibold text-primary md:text-[48px] md:leading-tight">
          International Excellence in Plastic Surgery
        </h2>

        <div className="mt-element space-y-8">
          {TIMELINE.map((row) => (
            <div
              key={row.detail}
              className="grid gap-6 border border-[#E2E8F0] bg-surface p-8 md:grid-cols-[minmax(0,220px)_1fr] md:gap-10"
            >
              <div className="font-body text-sm font-normal uppercase tracking-[1.5px] text-muted">
                {row.place}
              </div>
              <div className="font-body text-base font-light leading-relaxed text-ink">
                {row.detail}
              </div>
            </div>
          ))}
        </div>

        <blockquote className="mt-16 text-center">
          <p className="font-heading text-2xl font-semibold italic leading-snug text-primary md:text-[32px]">
            <span className="text-accent">&ldquo;</span>
            Natural results, uncompromising safety, and an unwavering respect
            for every patient&apos;s goals.
            <span className="text-accent">&rdquo;</span>
          </p>
        </blockquote>
      </div>
    </section>
  );
}
